import { useEffect } from 'react';
import { api } from '../services/api';
import { useAuthStore, type User } from '../store/authStore';

interface ProfileResponse {
  data: User;
}

/**
 * Hook that initializes auth state on app load.
 * If there's a token but user data might be stale, fetches fresh profile.
 */
export function useAuthInit(): void {
  const { token, isAuthenticated, setUser, logout, setLoading } = useAuthStore();

  useEffect(() => {
    if (!token || !isAuthenticated) return;

    setLoading(true);
    api.get<ProfileResponse>('/v1/users/me')
      .then((response) => {
        setUser(response.data);
      })
      .catch(() => {
        // Token invalid/expired — logout
        logout();
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
